const browserOptions = {};

const EMBED_AS_PARAM = 'embedAs';
const ALLOWED_EMBED_AS = [
  'dashboards',
  'all-dashboards',
  'dashboard',
  'mobiledashboard',
  'card',
];

function getBrowserOptions() {
  const params = new URLSearchParams(window.location.search);
  const embedAs = params.get(EMBED_AS_PARAM);
  if (embedAs && ALLOWED_EMBED_AS.includes(embedAs)) {
    browserOptions.embedAs = embedAs;
  }
  return browserOptions;
}

export default getBrowserOptions;
